import { accountJwt, AccountJwt } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class IAMAccountSignInResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountSignInResponseDTO.validationSchema()
  );

  constructor(readonly data: IAMAccountSignInResponseDTORaw) {
    JsonSchemaValidator.validate(IAMAccountSignInResponseDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["accountJwt"],
      properties: {
        accountJwt
      },
      additionalProperties: false
    };
  }
}

interface IAMAccountSignInResponseDTORaw {
  accountJwt: AccountJwt;
}
